<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1><i class="fa fa-dashboard"></i> {{ $t('reportCall') }}</h1>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><router-link to="/report/call">{{ $t('reportCall') }}</router-link></li>
      </ul>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-select :model="filterFormModel" attribute="group" class="mr-2 mb-2" :options="[
                            {value:'day',text:$t('byDays')},
                            {value:'user',text:$t('byStaffs')},
                            {value:'group',text:$t('byGroups')},
                            {value:'client',text: $t('byClients')},
                            {value:'host',text:$t('phoneHost')},
                            {value:'gateway',text:$t('gateway')},
                            {value:'network',text:$t('network')},
                            ]">
            </form-select>

            <client-select :model="filterFormModel" attribute="client" @input="load" class="mr-2 mb-2"></client-select>
            <network-select :model="filterFormModel" attribute="network" @input="load" class="mr-2 mb-2"></network-select>
            <host-select :model="filterFormModel" class="mr-2 mb-2"></host-select>
            <gateway-select :model="filterFormModel" class="mr-2 mb-2"></gateway-select>
            <form-select :model="filterFormModel" attribute="direction" class="mr-2 mb-2" :options="[
                            {value: null, text: this.$t('selectDirection')},
                            {value: 'incoming', text: this.$t('incoming')},
                            {value: 'outgoing', text: this.$t('outgoing')},
                            {value: 'local', text: this.$t('local')}
                            ]"></form-select>
            <time-range-picker :model="filterFormModel" :label="$t('time')" :defaultShortcut="2"
                               class="mr-2 mb-2"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-2 mb-2">{{ $t('search') }}</button>
            <!--                        <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>-->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="table-responsive c-template-table">
            <table class="table table-hover">
              <thead>
              <tr>
                <th></th>
                <th class="text-center">{{ $t('totalCount') }}</th>
                <th class="text-center">{{ $t('successCount') }}</th>
                <th class="text-center">{{ $t('busyCount') }}</th>
                <th class="text-center">{{ $t('rejectedCount') }}</th>
                <th class="text-center">{{ $t('invalidNumberCount') }}</th>
                <th class="text-center">{{ $t('networkBusyCount') }}</th>
                <th class="text-center">{{ $t('agentNetworkFailCount') }}</th>
                <th class="text-center">{{ $t('othersCount') }}</th>
                <th class="text-center">{{ $t('talkingTime') }}</th>
                <th class="text-center">{{ $t('waitingTime') }}</th>
                <th class="text-center">{{ $t('success20s') }}</th>
                <th class="text-center">{{ $t('success20m') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr class="bg-success">
                <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
                <td class="text-center"><span class="text-blue">{{ sum.total | numFormat('0,0')}}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.success | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.busy | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.rejected | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.invalidNumber | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.networkBusy | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.agentNetworkFail | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.other | numFormat('0,0') }}</span></td>
                <td class="text-center">{{ sum.billDuration | callDuration }}</td>
                <td class="text-center">{{ sum.duration - sum.billDuration | callDuration }}</td>
                <td class="text-center"><span class="text-blue">{{ sum.success20s | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.success20m | numFormat('0,0') }}</span></td>
              </tr>
              <tr class="bg-warning">
                <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                <td class="text-center"><span class="text-blue">{{ avg.total | numFormat('0,0.0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.success | numFormat('0,0.0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.busy | numFormat('0,0.0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.rejected | numFormat('0,0.0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.invalidNumber | numFormat('0,0.0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.networkBusy | numFormat('0,0.0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.agentNetworkFail | numFormat('0,0.0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.other | numFormat('0,0.0') }}</span></td>
                <td class="text-center">{{ avg.billDuration | callDuration }}</td>
                <td class="text-center">{{ avg.duration - avg.billDuration | callDuration }}</td>
                <td class="text-center"><span class="text-blue">{{ avg.success20s | numFormat('0,0.0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.success20m | numFormat('0,0.0') }}</span></td>
              </tr>
              <tr :key="index" v-for="(item, index) in data">
                <td style="min-width: 200px"><b>{{ label(item) }}</b></td>
                <td class="text-center"><span class="text-blue">{{ item.total | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.success | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.busy | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.rejected | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.invalidNumber | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.networkBusy | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.agentNetworkFail | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.other | numFormat('0,0') }}</span></td>
                <td class="text-center">{{ item.billDuration | callDuration }}</td>
                <td class="text-center">{{ item.duration - item.billDuration | callDuration }}</td>
                <td class="text-center"><span class="text-blue">{{ item.success20s | numFormat('0,0') }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.success20m | numFormat('0,0') }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="tile shadow">
          <h3 class="tile-title">{{ $t('calls') }}</h3>
          <apexchart :height="300" :options="chartOptions" :series="callChartData"></apexchart>
        </div>
      </div>
      <div class="col-md-6">
        <div class="tile shadow">
          <h3 class="tile-title">{{ $t('duration') }}</h3>
          <apexchart :height="300" :options="chartOptions" :series="durationChartData"></apexchart>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import moment from 'moment';
import TimeRangePicker from "../../components/TimeRangePicker";
import VueApexCharts from 'vue-apexcharts';
import ClientSelect from "../../components/ClientSelect";
import HostSelect from "@/components/HostSelect";
import GatewaySelect from "@/components/GatewaySelect";
import NetworkSelect from "@/components/NetworkSelect";

export default {
  components: {
    NetworkSelect,
    ClientSelect,
    TimeRangePicker,
    'apexchart': VueApexCharts,
    HostSelect,
    GatewaySelect
  },
  data() {
    return {
      filterFormModel: {
        group: 'day',
        direction: null,
        client: null,
        network: null,
        host: null,
        gateway: null
      },
      loading: true,
      data: [],
      sum: {},
      avg: {},
      chartOptions: {
        chart: {
          zoom: {enabled: false},
          type: 'line'
        }
      },
      callChartData: [],
      durationChartData: [],
    }
  },
  methods: {
    load() {
      let loader = this.$loading.show();
      this.loading = true;
      this.filterFormModel.to = moment(this.filterFormModel.to, 'x').endOf('day').format('x');
      this.$service.get('/report/call', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data;
        this.sum = {};
        this.avg = {};
        this.data.forEach(item => {
          item.other = item.total - (item.success + item.busy + item.rejected + item.invalidNumber + item.networkBusy + item.agentNetworkFail);
          for (let key in item) {
            if (!this.sum[key]) {
              this.sum[key] = 0;
            }
            this.sum[key] += item[key];
          }
        });
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length);
        }
        this.chartOptions = {
          xaxis: {
            categories: this.data.map(d => this.label(d)).slice(0, 99).reverse(),
            labels: {
              rotate: 0
            },
            tooltip: {
              enabled: false,
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return new Intl.NumberFormat().format(value);
              }
            },
          },
          chart: {
            zoom: {
              enabled: false
            },
            type: this.filterFormModel.group === 'day' ? 'line' : 'bar'
          }
        };
        this.callChartData = [
          {
            name: this.$t('totalCount'),
            data: this.data.map(d => d.total).slice(0, 99).reverse(),
          },
          {
            name: this.$t('successCount'),
            data: this.data.map(d => d.success).slice(0, 99).reverse(),
          },
          {
            name: this.$t('failureCount'),
            data: this.data.map(d => d.total - d.success).slice(0, 99).reverse(),
          },
        ];
        this.durationChartData = [
          {
            name: this.$t('duration'),
            data: this.data.map(d => d.duration/60).slice(0, 99).reverse(),
          },
          {
            name: this.$t('talkingTime'),
            data: this.data.map(d => d.billDuration/60).slice(0, 99).reverse(),
          },
          {
            name: this.$t('waitingTime'),
            data: this.data.map(d => (d.duration - d.billDuration)/60).slice(0, 99).reverse(),
          },
        ];
      }).finally(() => {
        loader.hide();
        this.loading = false;
      });
    },
    label(item) {
      if (item.label) {
        return item.label;
      }
      if (!isNaN(item._id)) {
        return moment(this.filterFormModel.from + item._id, 'x').format('ll');
      }
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        reportCall: 'Call report',
        byDays: 'By days',
        byStaffs: 'By staffs',
        byGroups: 'By groups',
        byClients: 'By clients',
        calls: 'Calls',
        duration: 'Duration',
        totalCount: 'Total',
        successCount: 'Connected',
        busyCount: 'Busy',
        rejectedCount: 'Rejected',
        invalidNumberCount: 'Invalid number',
        networkBusyCount: 'Network busy',
        agentNetworkFailCount: 'Agent network fail',
        failureCount: 'Fail to connect',
        othersCount: 'Others',
        talkingTime: 'Talking time',
        waitingTime: 'Waiting time',
        totals: 'Total',
        average: 'Average',
        selectDirection: "Select direction",
        incoming: 'Incoming',
        outgoing: 'Outgoing',
        local: 'Internal',
      success20s: "Call <=20 seconds",
      success20m: "Call >20 minutes"
      },
      vi: {
        reportCall: 'Báo cáo cuộc gọi',
        byDays: 'Theo ngày',
        byStaffs: 'Theo nhân viên',
        byGroups: 'Theo nhóm',
        byClients: 'Theo client',
        calls: 'Cuộc gọi',
        duration: 'Thời lượng',
        totalCount: 'Tổng',
        successCount: 'Kết nối thành công',
        busyCount: 'Máy bận',
        rejectedCount: 'Từ chối',
        invalidNumberCount: 'Sai số',
        networkBusyCount: 'Mạng bận',
        agentNetworkFailCount: 'Lỗi mạng của agent',
        failureCount: 'Kết nối thất bại',
        othersCount: 'Khác',
        talkingTime: 'Thời gian đàm thoại',
        waitingTime: 'Thời gian chờ',
        totals: 'Total',
        average: 'Average',
        selectDirection: "Chọn hướng gọi",
        incoming: 'Gọi vào',
        outgoing: 'Gọi ra',
        local: 'Gọi nội bộ',
        success20s: "Cuộc gọi <=20 giây",
        success20m: "Cuộc gọi >20 phút"
      }
    }
  }
};
</script>